import * as service from "./service";
import { emit } from "./event";
import { getBusinessId, setBusinessId } from "./business.js";
import { setWaterMark } from "../utils/util";

// 是否是第一次进入
let isFirstTime = true;

export default {
    namespaced: true,
    state: {
        time: undefined,
        mid: undefined,
        name: undefined,
        role_id: undefined,
        role_name: undefined,
        group_list: undefined,
        permit: undefined,
        token: undefined,
        businessId: getBusinessId(), // 当前业务id
        businessSetting: null,
        business_list: [] // 用户拥有业务列表
    },
    mutations: {
        update(state, payload = {}) {
            Object.keys(payload).forEach(key => {
                state[key] = payload[key];
            });

            // 当前没有选择业务，或者业务不在业务列表里，默认选择第一个业务
            if (state.business_list.length && !state.business_list.find(bs => bs.business_id == state.businessId)) {
                state.businessId = state.business_list[0].business_id;
                setBusinessId(state.businessId); // 更新到storage 缓存用户上次查看的业务
            }

            // 过滤掉pubg特有的权限
            if (state.businessId !== 1000) {
                const deletePermits = ["knowledge.wikipage"];
                const idxs = [];
                deletePermits.forEach(permit => {
                    const idx = (state.permit || []).indexOf(permit);
                    if (idx != -1) {
                        idxs.push(idx);
                    }
                });
                idxs.sort((before, next) => (before < next ? 1 : -1));
                idxs.forEach(idx => state.permit.splice(idx, 1));
            }
            state.time = +new Date();
        }
    },
    actions: {
        async update({ commit }) {
            try {
                const userInfo = await service.info();
                commit("update", userInfo);

                if (isFirstTime && userInfo.token) {
                    // 有登录态 +
                    //   第一次进入这个页面
                    //   或 从 login 页面进入这个页面
                    // 触发 inited 事件
                    // 其他情况是第二次进入这个页面的，不应该
                    isFirstTime = false;

                    const businessSetting = await service.businessSetting(); // 业务设置数据
                    commit("update", { businessSetting });

                    emit("inited");
                    setWaterMark(userInfo.name);
                }
            } catch (err) {
                commit("update");
            }
        },
        logout() {
            // 触发登出事件
            emit("logout");
            service.logout();
        }
    }
};
